<div class="cell auto grid-y cell-block-y blockContent">
    <div class="cell shrink" *ngIf="barChartData">
        <canvas baseChart
                height="100vh"
                [datasets]="barChartData"
                [labels]="[(barChartLabel | translate)]"
                [options]="barChartOptions"
                [legend]="barChartLegend"
                [type]="barChartType">
        </canvas>
    </div>

    <spacer *ngIf="teamsData" size="24"></spacer>

    <kiwi-teams-data [teamsData]="teamsData" [teamValueLabelKey]="teamValueLabelKey">
    </kiwi-teams-data>
</div>
